import Text from '../base/Text';

export default function CircularProgressIndicator({
  progress,
  className,
  strokeWidth = 4,
  radius = 52,
}: {
  progress?: number;
  className?: string;
  strokeWidth?: number;
  radius?: number;
}) {
  return (
    <div
      className={`relative ${className}`}
      style={{ width: radius * 2, height: radius * 2 }}
    >
      <div className="absolute left-0 top-0 flex h-full w-full items-center justify-center">
        <Text variant="studio/title/lg">
          {progress !== undefined ? `${Math.round(progress)}%` : ''}
        </Text>
      </div>
      <svg
        width={radius * 2}
        height={radius * 2}
        viewBox="0 0 104 104"
        style={{ transform: 'rotate(-90deg)' }}
      >
        <circle
          r={50}
          cx={52}
          cy={52}
          fill="transparent"
          strokeWidth={strokeWidth}
          className="stroke-gray-30 dark:stroke-gray-60"
        />
        <circle
          r={50}
          cx={52}
          cy={52}
          fill="transparent"
          stroke="#65F157"
          strokeLinecap="square"
          strokeWidth={strokeWidth}
          strokeDasharray={2 * 3.14 * 50}
          strokeDashoffset={2 * 3.14 * 50 * ((100 - (progress || 0)) / 100)}
          style={{
            transition: 'stroke-dashoffset 250ms linear, stroke 250ms linear',
          }}
        />
      </svg>
    </div>
  );
}
